/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */

import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Badge, Breadcrumb, Button, Card, Input, message } from 'antd';
import { ReloadOutlined, EyeOutlined } from '@ant-design/icons';
import {
	deleteCorporate,
	getAllCorporates,
	getCorporateById,
	resetSelectedCorporate,
} from '../../redux/corporateSlice';
import { style } from '../../Styles';
import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';
import CorporateDrawer from './CorporateDrawer';

import ActionButton from '../Global/ActionsButton';
import CorporateModal from './CorporateModal';
import { SHARED_PRIVATE } from '../../Utils/Constants/utils';

const corporateModalTitle = {
	riders: 'Riders List',
	schedule: 'Schedule',
	allowedAreas: 'Allowed Areas',
	discount: 'Discount',
	admins: 'Admins List',
};

const Corporate = ({ role }) => {
	const { corporates } = useSelector((state) => state.corporates);
	const [search, setSearch] = useState('');
	const searchTimerRef = useRef(null);
	const [isDrawerOpened, setIsDrawerOpened] = useState(false);
	const [corporateId, setCorporateId] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [title, setTitle] = useState('');
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortBy, setSortBy] = useState('id');
	const [sortDirection, setSortDirection] = useState('DESC');

	const closeDrawer = () => {
		setIsDrawerOpened(false);
		setCorporateId(null);
	};

	const openDrawer = (record) => {
		setIsDrawerOpened(true);
		if (record) setCorporateId(record.id);
	};
	const dispatch = useDispatch();
	const fetchCorporates = () => {
		dispatch(getAllCorporates({ page: currentPage - 1, size: pageSize, search, sortBy, sortDirection }));
	};

	const handleTableChange = (_, __, sorter, extra) => {
		if (extra?.action !== 'sort') return;
		if (sorter.order) {
			setSortBy(sorter.columnKey || sorter.field);
			setSortDirection(sorter.order === 'ascend' ? 'ASC' : 'DESC');
		} else {
			setSortBy('id');
			setSortDirection('DESC');
		}
		setCurrentPage(1);
	};

	const openModal = (titleType, selectedCorporateId) => {
		dispatch(getCorporateById(selectedCorporateId));
		setIsModalOpen(true);
		setTitle(corporateModalTitle[titleType]);
		setCorporateId(selectedCorporateId);
	};

	const onModalClose = () => {
		dispatch(resetSelectedCorporate());
		setIsModalOpen(false);
		setTitle('');
		setCorporateId(null);
	};

	useEffect(() => {
		fetchCorporates();
	}, [currentPage, pageSize, search, sortBy, sortDirection]);

	const handleDelete = (id, calbback) => {
		dispatch(deleteCorporate(id))
			.unwrap()
			.then(() => {
				message.success('Make deleted successfully');
				calbback();
			})
			.catch(() => { });
	};

	const columns = [
		{
			title: 'ID',
			dataIndex: 'id',
			key: 'id',
			sorter: true,
		},
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
			sorter: true,
		},
		{
			title: 'Applied For',
			dataIndex: 'appliedFor',
			key: 'appliedFor',
			render: (record) => {
				return <span>{record === SHARED_PRIVATE ? 'SHARED & PRIVATE' : record}</span>;
			}
		},
		{
			title: 'Admins',
			key: 'admins',
			render: (record) => {
				return (
					<span style={style.btnView}>
						{record?.admins?.length > 0 ? (
							<Button
								type='default'
								style={{ height: 30 }}
								onClick={() => {
									openModal('admins', record.id);
								}}>
								<EyeOutlined />
							</Button>
						) : (
							<Badge dot>
								<Button
									type='default'
									style={{ height: 30 }}
									onClick={() => {
										openModal('admins', record.id);
									}}>
									<EyeOutlined />
								</Button>
							</Badge>
						)}
					</span>
				);
			},
			width: 150,
		},
		{
			title: 'Riders',
			key: 'riders',
			render: (record) => {
				return (
					<span style={style.btnView}>
						{record?.riders?.length > 0 ? (
							<Button
								type='default'
								style={{ height: 30 }}
								onClick={() => {
									openModal('riders', record.id);
								}}>
								<EyeOutlined />
							</Button>
						) : (
							<Badge dot>
								<Button
									type='default'
									style={{ height: 30 }}
									onClick={() => {
										openModal('riders', record.id);
									}}>
									<EyeOutlined />
								</Button>
							</Badge>
						)}
					</span>
				);
			},
			width: 150,
		},
		{
			title: 'Discount',
			key: 'discount',
			render: (record) => {
				return (
					<span style={style.dataContainer}>
						{record?.discount ? (
							<Button
								type='default'
								style={{ height: 30 }}
								onClick={() => {
									openModal('discount', record.id);
								}}>
								<EyeOutlined />
							</Button>
						) : (
							<Badge dot>
								<Button
									type='default'
									style={{ height: 30 }}
									onClick={() => {
										openModal('discount', record.id);
									}}>
									<EyeOutlined />
								</Button>
							</Badge>
						)}
					</span>
				);
			},
			width: 150,
		},
		{
			title: 'Allowed Areas',
			key: 'allowedAreas',
			render: (record) => {
				return (
					<span style={style.dataContainer}>
						{record?.allowedAreas?.length > 0 ? (
							<Button
								type='default'
								style={{ height: 30 }}
								onClick={() => {
									openModal('allowedAreas', record.id);
								}}>
								<EyeOutlined />
							</Button>
						) : (
							<Badge dot>
								<Button
									type='default'
									style={{ height: 30 }}
									onClick={() => {
										openModal('allowedAreas', record.id);
									}}>
									<EyeOutlined />
								</Button>
							</Badge>
						)}
					</span>
				);
			},
			width: 150,
		},
		{
			title: 'Schedule',
			key: 'schedule',
			render: (record) => {
				return (
					<span style={style.dataContainer}>
						{record?.schedules ? (
							<Button
								type='default'
								style={{ height: 30 }}
								onClick={() => {
									openModal('schedule', record.id);
								}}>
								<EyeOutlined />
							</Button>
						) : (
							<Badge dot>
								<Button
									type='default'
									style={{ height: 30 }}
									onClick={() => {
										openModal('schedule', record.id);
									}}>
									<EyeOutlined />
								</Button>
							</Badge>
						)}
					</span>
				);
			},
			width: 150,
		},
		{
			title: 'Actions',
			key: 'actions',
			render: (text, record) => (
				<ActionButton
					record={record}
					onDelete={() => handleDelete(record.id)}
					onEdit={() => openDrawer(record)}
				/>
			),

		},
	];
	const data = corporates?.corporatesList ? Object.values(corporates.corporatesList) : [];

	return (
		<Card style={{
			margin: 16,
			maxHeight: '90%', // Set maximum width
			height: 'auto', // Allow width to be dynamic
		}}>
			<div style={style.inlineContent}>
				<div
					style={{
						display: 'flex',
						alignContent: 'center',
						alignItems: 'center',
						float: 'left',
						marginBottom: 8,
					}}>
					<Breadcrumb
						style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
						items={[
							{
								title: 'Corporates',
							},
						]}
					/>
					<Button type='default' size='small' onClick={() => fetchCorporates()}>
						<ReloadOutlined />
					</Button>
				</div>

				<div
					style={{
						...style.inlineContent,
						float: 'right',
						marginBottom: 8,
					}}>
					<Input.Search
						placeholder='Search'
						allowClear
						style={{ margin: '0 8px 8px 0' }}
					onSearch={(value) => { if (searchTimerRef.current) clearTimeout(searchTimerRef.current); setSearch(value); setCurrentPage(1); }}
					onChange={(e) => { const val = e.target.value; if (searchTimerRef.current) clearTimeout(searchTimerRef.current); searchTimerRef.current = setTimeout(() => { setSearch(val); setCurrentPage(1); }, 400); }}
					/>
					{role?.includes('SUPER_ADMIN') && (
						<Button
							type='default'
							style={{ float: 'right', marginBottom: 8 }}
							onClick={() => openDrawer()}>
							Add Corporate
						</Button>
					)}
				</div>
			</div>
			<CustomTableComponentsPageable
				isMakingApiCall={corporates?.loading}
				columns={columns}
				dataArray={data}
				handleDoubleClickRow={(record) => {
					openDrawer(record);
				}}
				handleSelectedRow={() => { }}
				onTableChange={handleTableChange}
				pagination={{
					current: currentPage,
					pageSize,
					total: corporates?.total || 0,
					onChange: (page, size) => {
						setCurrentPage(page);
						setPageSize(size);
					},
				}}
			/>
			{isDrawerOpened && (
				<CorporateDrawer
					onClose={closeDrawer}
					corporateId={corporateId}
					dispatch={dispatch}
				/>
			)}
			{isModalOpen && (
				<CorporateModal
					isModalOpen={isModalOpen}
					title={title}
					onModalClose={onModalClose}
				/>
			)}
		</Card>
	);
};

export default Corporate;
